export const FONT_SIZE_REGULAR = "14px";
export const FONT_SIZE_L_REGULAR = "15px";
export const FONT_SIZE_SMALL = "12px";
export const FONT_SIZE_LARGE = "16px";
export const FONT_SIZE_VSMALL = "11px";
